import React, { ReactElement } from 'react'
import { useParams } from 'react-router-dom'
import { ICustomHTTPError } from '../../types/http'
import {
  deleteScheduleModalClose,
  scheduleRequestFinish,
  scheduleRequestStart,
} from '../../actions/publishSchedule'
import { trace } from '../../services/common'
import { deleteSchedule } from '../../services/publishSchedule'
import { usePublishSchedule, useFetchSchedules } from './hooks'
import { messages } from '../../config/messages'
import Modal from '../Modal'
import { P } from '../StyledText'
import { useCustomSnackbar } from '../CustomSnackbar/hook'

export const DeletePublishScheduleModal = (): ReactElement => {
  const { packId } = useParams()
  const [
    { displayDeleteModal, currentScheduleId },
    dispatch,
  ] = usePublishSchedule()
  const fetchSchedules = useFetchSchedules()
  const [, setSnackbarMessage] = useCustomSnackbar()

  const handleDeleteSuccess = () => {
    setSnackbarMessage('The schedule has been successfully deleted.')
    fetchSchedules()
    dispatch(scheduleRequestFinish())
    dispatch(deleteScheduleModalClose())
  }

  const handleDeleteError = (err: ICustomHTTPError) => {
    trace(err)
    if (err.code === 404) {
      setSnackbarMessage(messages.scheduleMayBeDeletedFailure)
    } else {
      setSnackbarMessage(err.message)
    }
    dispatch(scheduleRequestFinish())
  }

  const handleDelete = async (): Promise<void> => {
    if (!!currentScheduleId) {
      try {
        dispatch(scheduleRequestStart())
        await deleteSchedule(currentScheduleId, packId)
        handleDeleteSuccess()
      } catch (err) {
        handleDeleteError(err)
      }
    }
  }

  return (
    <Modal
      id="delete-schedule-modal-dialog"
      open={displayDeleteModal}
      handleClose={() => dispatch(deleteScheduleModalClose())}
      action={handleDelete}
      title="Schedule deletion"
      actionLabel="Delete"
    >
      <P>
        This schedule will be deleted - please note that this action is not
        reversible and cannot be undone.
      </P>
      <br />
      <P>Are you sure you want to delete it?</P>
    </Modal>
  )
}
